<template>
  <div id="container" ref="mapRef" class="mainBox"></div>
  <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
  <div class="navBox"><Nav curNavId="1" pathUrl='gbzntjs' @circle="clickNav" /></div>
  <div class="left flexColumn">
    <div class="leftBox1 flexColumn">
      <div class="title">巡检记录</div>
      <div class="videoBox flexColumn">
        <dv-scroll-board
          :config="state.config"
          style="width: 100%; height: 100%; font-size: 30px"
        />
      </div>
    </div>
    <div class="leftBox2 flexColumn">
      <div class="title">巡检任务类型</div>
      <div class="xunj_box">
        <dv-scroll-board
          :config="state.config1"
          style="width: 100%; height: 100%; font-size: 30px"
        />
      </div>
    </div>
    <div class="leftBox3 flexColumn">
      <div class="title">设备类型</div>
      <div class="leftInfo3">
        <div class="sb_box" v-for="item in state.leftData1" :key="index">
          <img :src="item.img">
          <span >{{item.name}}</span>
          <span class="span1">{{item.sl}}</span>

        </div>

      </div>
    </div>
  </div>
  <div class="right flexColumn">
    <div class="rightBox1 flexColumn">
      <div class="title">设备列表</div>
      <div class="rightBox1_txt">

        <div class="rightBox1_txt_nr" v-for="item in state.rightData" :key="index">
          <div class="imgs">
            <img :src="item.img">
          </div>
          <div class="sblb">
            <span class="span1">{{item.name}}</span>
            <span class="span2">{{item.sl}}</span>
          </div>

        </div>


      </div>

    </div>
    <div class="rightBox2 flexColumn">
      <div class="title">报警列表</div>
      <div class="rightBox2_txt">
        <dv-scroll-board
          :config="state.config3"
          style="width: 100%; height: 100%; font-size: 30px"
        />

      </div>
    </div>
    <div class="rightBox3 flexColumn">
      <div class="title">信号采集率</div>
      <div class="rightBox2_txt">

        <rightLine/>
      </div>

    </div>
  </div>
  <CircleNav :isShow="state.circleShow"  @closeCircle1="circleHiddlen"  />
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";

// todo 项目使用请放开 leaflet 引入
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import * as L from 'leaflet/dist/leaflet.esm.js';
import Gep from "../utils/map.json";
import rightLine from "../components/xuntian/rightLine";


import Nav from "../components/nav.vue";
import CircleNav from "@/components/circleNav.vue";
import {getRandomDate} from "@/utils/getRandomDate";

// const timer = ref(null);
const router = useRouter();
const mapRef = ref(null);
const state = reactive({
  url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
  AccessToken: "",
  imgShow:false,
  circleShow:false,
  config: {
    header: [
      '<span style="color:#94E894; font-size:18px;">巡检时间</span>',
      '<span style="color:#94E894;font-size:18px;">巡检名称</span>',
      '<span style="color:#94E894;font-size:18px;">巡检记录</span>',
      '<span style="color:#94E894;font-size:18px;">巡检人</span>',
    ],
    data: [
      ["2024-03-20", "地块1巡检", "巡检","赵波"],
      ["2024-03-27", "地块2巡检", "维护","赵波"],
      ["2024-04-01", "地块3巡检", "巡检","赵波"],
      ["2024-04-16", "地块1巡检", "维护","赵波"],
      ["2024-04-20", "地块2巡检", "巡检","赵波"],
      ["2024-05-03", "地块3巡检", "维护","赵波"],
    ],
    headerBGC: "",
    oddRowBGC: "#102834",
    evenRowBGC: "",
    headerHeight: 40, // index: true,
    // columnWidth: [150],
    rowNum:4,
    align: ["center", "center", "center","center"], // rowNum:6
  },
  config1: {
    data: [
      ["2024-03-20", "巡视地块1", "查看虫情"],
      ["2024-03-27", "巡视地块2", "检查设备"],
      ["2024-04-01", "巡视地块3", "查看虫情"],
      ["2024-04-07", "巡视地块1", "检查设备"],
      ["2024-04-10", "巡视地块2", "查看虫情"],
      ["2024-04-16", "巡视地块3", "检查设备"],
    ],
    headerBGC: "",
    oddRowBGC: "#07252A",
    evenRowBGC: "",
    headerHeight: 40, // index: true,
    // columnWidth: [150],
    rowNum:4,
    align: ["center", "center", "center","center"], // rowNum:6
  },
  config3: {
    header: [
      '<span style="color:#94E894; font-size:18px;">名称</span>',
      '<span style="color:#94E894;font-size:18px;">预警时间</span>',
      '<span style="color:#94E894;font-size:18px;">报警内容</span>',

    ],
    data: [
      ["杀虫灯1号","2024-04-20",  "设备异常",],

      ["水电双计86号","2024-04-26", "设备异常", ],
      ["水电双计56号","2024-05-03", "设备异常", ],
    ],
    headerBGC: "",
    oddRowBGC: "#102834",
    evenRowBGC: "",
    headerHeight: 40, // index: true,
    // columnWidth: [150],
    rowNum:4,
    align: ["center", "center", "center","center"], // rowNum:6
  },
  leftData1: [
    {
      name: "杀虫灯",
      sl: "17",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xuntian/sc.png",


    },
    {
      name: "孢子仪",
      sl: "1",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xuntian/pz.png",


    },
    {
      name: "水电双计",
      sl: "123",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xuntian/sc.png",


    },
    {
      name: "监控设备",
      sl: "11",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xuntian/sc.png",


    },
    {
      name: "虫情测报灯",
      sl: "1",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xuntian/pz.png",


    },
    {
      name: "水肥一体机",
      sl: "28",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xuntian/sc.png",


    },

  ],
  rightData: [
    {
      name: "在线设备",
      sl: "177个",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xuntian/zx.png",


    },
    {
      name: "异常设备",
      sl: "3个",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xuntian/yc.png",


    },
    {
      name: "接入设备",
      sl: "187个",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xuntian/jr.png",


    },
    {
      name: "预警数据",
      sl: "6个",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xuntian/yj.png",


    },


  ],
});

const emit = defineEmits(["mapLoad"]);
const boundaryData = Gep;

const marker = ref();
const map = ref(null);
let current = ref(0);

// 地图底图
// 第一种
let mapType = ref("vec");
let mapLabelType = ref("cva");

// let mapType1 = ref(
//   L.tileLayer(
//     "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&x={x}&y={y}&z={z}",
//     {
//       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
//     }
//   )
// );

// let mapType1 = ref(
//   L.tileLayer(
//     "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
//     {
//       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
//     }
//   )
// );
let mapType1 = ref(
  L.tileLayer(
    "https://map1.aikenong.com.cn/maps/vt/lyrs=y&hl=zh-CN&gl=cn&scale=2&src=app&x={x}&y={y}&z={z}",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    }
  )
)
let mapLabelType1 = ref(
  L.tileLayer(
    "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    }
  )
);
// let mapLabelType1 = ref(
//   L.tileLayer(
//     "https://t{s}.tianditu.gov.cn/" +
//       "cva" +
//       "_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=" +
//       "cva" +
//       "&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
//     {
//       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
//     }
//   )
// );

const initMap = () => {
  map.value.addLayer(mapType1.value);
  map.value.addLayer(mapLabelType1.value);
  map.value.on("click", ({ latlng }) => {
    console.log("坐标：", Object.values(latlng));
  });

  return map.value;
};

const mapObj = ref();
// 添加行政区划边界的逻辑
const loadBoundary = () => {
  L.geoJSON(boundaryData, {
    onEachFeature: function (feature, layer) {
      let style;

      switch (feature.properties.T) {
        case "未建成":
          style = {
            color: "热点",
            fillColor: "red",
            fillOpacity: 0.45,
            dashArray: [5, 5],
            weight: 0,
          };
          break;
        case "其他":
          style = {
            color: "green",
            fillColor: "#78C683",
            fillOpacity: 0.45,
            dashArray: [5, 5],
            weight: 0,
          };
          break;
        default:
          style = {
            color: "#fff",
            fillColor: "#6763ED",
            fillOpacity: 0.45,
            dashArray: [5, 5],
            weight: 1,
          };
      }

      if (
          feature.geometry.type === "Polygon" ||
          feature.geometry.type === "MultiPolygon"
      ) {
        // 设置填充样式
        layer.setStyle(style);

        // 处理每个外环线为虚线
        feature.geometry.coordinates.forEach((ring, index) => {
          if (index === 0 || feature.geometry.type === "Polygon") {
            // 对于多边形，只处理外环线
            const dashedLine = createDashedPolyline(
                { geometry: { coordinates: [ring] } },
                style
            );
            map.value.addLayer(dashedLine);
          }
        });
      } else if (
          feature.geometry.type === "LineString" ||
          feature.geometry.type === "MultiLineString"
      ) {
        const dashedLine = createDashedPolyline(feature, style);
        map.value.addLayer(dashedLine);
      }

      // 添加原始图层到地图上（用于显示填充区域）
      map.value.addLayer(layer);
    },
  }).addTo(map.value);
};
const removeMap = () => {
  if (mapObj.value) {
    mapObj.value.remove();
  }
};

// 新增一个清除所有标记的方法
function clearMarkers() {
  // 如果map.value存在并且有layers，则遍历删除所有标记
  if (map.value && map.value.eachLayer) {
    map.value.eachLayer((layer) => {
      if (layer instanceof L.Marker) {
        map.value.removeLayer(layer);
      }
    });
  }
}
// 假设有个按钮点击事件，用buttonClick表示
function buttonClick(index) {
  // 清除所有已存在的标记
  clearMarkers();

  // 筛选出iconName为"1.png"的标记数据
  const filteredMarkers = markersData.find(
    (markerDatum) => markerDatum.iconName === index + ".png"
  );

  // 遍历筛选出来的标记数据，添加到地图上
  if (filteredMarkers) {
    for (const latlng of filteredMarkers.locations) {
      const iconPath = require(`../assets/img/icon/${filteredMarkers.iconName}`);

      const marker = createAndAddMarker(latlng, {
        title: `地标`,
        icon: L.icon({
          iconUrl: iconPath,
          iconSize: [34, 48],
          iconAnchor: [22, 94],
          popupAnchor: [-3, -76],
        }),
      });

      // 添加自定义的弹出内容
      // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;border: 1px solid #19e1cb;'>${
      //   filteredMarkers.title ? filteredMarkers.title : "地标"
      // }</div>`;
      // marker.bindPopup(popupContent);
    }
  }
}

// 定义一个函数用来创建和添加Marker
function createAndAddMarker(latlng, options = {}) {
  const marker = L.marker(latlng, options);
  marker.addTo(map.value);
  return marker;
}
const markersData = [
  {
    locations: [
      [33.257781131561195, 114.1743850708008],
      [33.24184615600892, 114.18193817138672],
      [33.24477,114.19036],
      [33.258355310672435, 114.16442871093751],
      [33.24371256462256, 114.16460037231447],
      [33.22806221263595, 114.20391082763672],
      [33.22791861845797, 114.18022155761719],
      [33.221169426180474, 114.18434143066408]
    ],
    iconName: "xt.png",
    // 其他相关属性...
  },


];

function createDashedPolyline(feature, style) {
  const latLngs = feature.geometry.coordinates;
  if (feature.geometry.type === "Polygon") {
    // 取外圈线作为多段线处理
    latLngs = [latLngs[0]];
  } else if (feature.geometry.type === "MultiPolygon") {
    // 处理多个多边形，这里仅取第一个外圈线
    latLngs = [latLngs[0][0]];
  }

  const options = {
    ...style,
    dashArray: [5, 5], // 虚线长度与间距
    lineCap: "round", // 线头样式，可选
    lineJoin: "round", // 线交接处样式，可选
  };

  return L.polyline(latLngs, options);
}
// 初始化地图
function loadMap(){
  map.value = L.map(mapRef.value, {
    center: [33.248258780732435, 114.18800353654662],

    // center: [114.182633, 33.240019],
    zoom: 13,
    minZoom: 3,
    maxZoom: 19,
    noWrap: true,
    // dragging: false,
    zoomControl: true,
    attributionControl: false,
  });
  mapObj.value = initMap();
  // createMarkers();
  loadBoundary();
  for (const markerDatum of markersData) {
    for (const latlng of markerDatum.locations) {
      const iconPath = require(`../assets/img/icon/${markerDatum.iconName}`);

      const marker = createAndAddMarker(latlng, {
        title: `地标`,
        icon: L.icon({
          iconUrl: iconPath,
          iconSize: [34, 48], // 图标大小
          iconAnchor: [22, 94], // 图标锚点
          popupAnchor: [-3, -76], // 弹出窗锚点
        }),
      });

      // 假设没有针对每个点定制的弹出内容，可以根据需求添加
      // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;'>${
      //   markerDatum.title ? markerDatum.title : "地标"
      // }</div>`;
      // marker.bindPopup(popupContent);
    }
  }
}


function clickNav(isShow){
  // console.log(isShow)
  state.circleShow = isShow.show
}
function circleHiddlen(data1){
  // console.log('circle')
  state.circleShow = data1.show
}

// 截取文字
function chunkString(str, chunkSize) {
  if (str.length <= chunkSize) {
    return [str];
  }
  return [str.slice(0, chunkSize), ...chunkString(str.slice(chunkSize), chunkSize)];
}

// 加载日期
const clearLocalStorage = (name) => {
  localStorage.removeItem(name);
  console.log("清除")
};
let intervalId = null;
// 左侧折线图 获取日期
function getDate(numDays,type,name){
  console.log(type)
  let dateArr=[]
  let recentDate = localStorage.getItem(name);
  // console.log(recentDate)
  if(recentDate){
    dateArr = recentDate.split(',')
  }else{
    const daysAgo = ref(numDays,type);
    const recentDate = getRandomDate(daysAgo.value,type);
    // console.log(recentDate)
    localStorage.setItem(name, recentDate);
    // console.log(localStorage.getItem(name))
    intervalId = setInterval(clearLocalStorage(name), 3 * 24 * 60 * 60 * 1000);
    dateArr = recentDate
  }
  return dateArr
}
// 在 onMounted 中初始化地图
onMounted(() => {
  // 获取视频AccessToken
  state.AccessToken = localStorage.getItem("AccessToken");
  console.log(state.AccessToken);
  const text = "为深入贯彻落实党的二十大精神，按照新形势下国家粮食安全和农业可持续发展的总体要求，深入贯彻落实“藏粮于地、藏粮于技”战略，以推进农业现代化为目标，以促进农业可持续发展为主线，加强高标准农田建设，支持生态综合治理，提高农田抗御旱涝灾害的能力，加强农业基础设施建设，改善农业生产条件，提高农业特别是粮食综合生产能力。上蔡县委、县政府根据全县经济社会发展需求和自身条件，特别是县域耕地数量、质量和农业发展现状，经过多次规划选址、研讨论证，最终选定位于县城西南部的无量寺、大路李、黄埠3个乡镇的14个行政村和1个农场、1个种子站，集中连片5万亩耕地，作为县农业现代化高标准农田示范区。其中，以吴宋湖农场周边区域1.5万亩作为核心区先行打造。";
  state.textList = chunkString(text, 44);

  // 左侧时间
  let dateArr = getDate(6,4,'xuntian1')
  console.log(dateArr)
  for(var i=0;i<state.config.data.length;i++){
    state.config.data[i][0] = dateArr[i]
    state.config1.data[i][0]= dateArr[i]
  }
  // 右侧报警列表时间
  let dateArr1 = getDate(3,4,'xuntian2')
  console.log(dateArr1)
  for(var i=0;i<state.config3.data.length;i++){
    state.config3.data[i][1] = dateArr[i]
  }

  // 加载地图
  loadMap()
});
onUnmounted(() => {
  removeMap();
  // 清除定时器
  if (intervalId) {
    clearInterval(intervalId);
  }
});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .videoBox .header{
  background-color: #05363D;

}
::v-deep .rightBox2_txt .header{
  background-color: #05363D;

}
::v-deep .rightBox2_txt .dv-scroll-board .rows .row-item{
  font-size: 18px;

}


::v-deep .videoBox .dv-scroll-board .rows .row-item{
  font-size: 16px;
}
::v-deep .xunj_box .dv-scroll-board .rows .row-item{
  font-size: 18px;

}
::v-deep .xunj_box .dv-scroll-board .rows .row-item .ceil:first-child{
  font-size: 20px;
  color:#FFA011 ;
}
::v-deep .rightBox2_txt .dv-scroll-board .rows .row-item .ceil:last-child{
  font-size: 20px;
  color:#94E894 ;
}

.navBox{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 150px;
  background: linear-gradient( to bottom, rgba(3, 14, 25, 1) 0%,  rgba(3, 14, 25, 0.7) 60%,  rgba(3, 14, 25, 0));
}
.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.flexColumn{
  display: flex;
  flex-direction: column;
}
.title{
  width:100%;
  height: 50px;
  font-weight: bold;
  background: url("../assets/img/huanjing/xbt.png") no-repeat left bottom;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  text-align: left;
  padding-left: 30px;
  padding-top: 15px;
}
.left,.right{
  position: fixed;
  top: 100px;
  width: 468px;
  height: calc(100% - 120px);
  background: url("../assets/img/huanjing/ck.png") no-repeat;
  background-size: 100% 100%;
  z-index: 1000;

  //padding: 20px 0;
  //border: 1px solid #fff;
}

.left{
  left: 10px;
  .leftBox1{
    height: 324px;
    align-items: center;
    .videoBox{
      width: 448px;
      height: 270px;
      padding: 10px 0;

    }
  }
  .leftBox2{
    flex: 1;
    .xunj_box{
      width: 100%;
      flex: 1;
      padding: 20px 10px;
    }
  }
  .leftBox3{
    height: 325px;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 14px;
    .leftInfo3{
      width: 100%;
      flex: 1;
      display: flex;
      flex-wrap: wrap;

      .sb_box{
        width: 33.33%;
        height: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;



      }
      img{
        width: 64px;
        height: 66px;
      }
      span{
        display: block;
        font-size: 16px;
        color: #fff;
        line-height: 30px;
      }
      .span1{
        display: block;
        font-size: 16px;
        color: #27A0FF;
        line-height: 20px;
      }


    }
  }
}
.right{
  right: 10px;
  .rightBox1{
    width: 100%;
     height: 260px;
    .rightBox1_txt{
      flex: 1;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .rightBox1_txt_nr{
        width: 50%;
        height: 44%;
        display: flex;
        margin-top: 3%;
        //justify-content: center;
        //align-items: center;
        .imgs{
          width: 66px;
          height: 100%;
          margin-left: 50px;

          img{
            width: 100%;
            height: 64px;
          }

        }
        .sblb{
          flex: 1;
          height: 100%;
          .span1{
            display: block;
            width: 100px;
            font-size: 22px;
            color: #078C67;
            line-height: 30px;

          }
          .span2{
            width: 100px;
            display: block;
            font-size: 24px;
            color: #fff;
            line-height: 35px;

          }

        }

      }

    }
  }
  .rightBox2_txt{
    margin-top: 20px;
    width: 100%;
    flex: 1;
    padding: 0 10px;
  }
  .rightBox2{
   flex: 1;
    padding-bottom: 15px;

  }
  .rightBox3{
    flex: 1;
    //height: 302px;
  }
}


</style>
